import React from "react"
import {
  Container,
  Section,
  Background,
  Content,
  ContentWrapper,
  Headline,
  Description,
  Action,
  ActionButton,
  Picture,
} from "./style"

const BannerWithLeftPicture = ({
  headline,
  description,
  actions,
  picture,
}: IBannerWithLeftPicture) => {
  return (
    <Section>
      <Container>
        <Background />
        <Content>
          <ContentWrapper>
            <Headline>{headline}</Headline>
            <Description>{description}</Description>
            <Action>
              {actions.map((a, k) => (
                <ActionButton key={k} to={a.url}>
                  {a.button}
                </ActionButton>
              ))}
            </Action>
          </ContentWrapper>
          <Picture>
            <img src={picture} />
          </Picture>
        </Content>
      </Container>
    </Section>
  )
}

export default BannerWithLeftPicture
